import React, { useMemo, useState } from 'react';
import { Container, TableSortLabel, Typography } from '@mui/material';
import Table from 'components/Common/StyledTable';
import TextInput from 'components/Common/TextInput';
import { dateFormat, formatAmount, timeFormat } from 'utils/helpers';
import { BasketActivityUser } from 'types/baskets';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { updateTableState } from 'redux/slices/common/appSlice';

const columns = [
    { id: 'createdDate', label: 'Date', render: ({ value }: any) => dateFormat(value) },
    { id: 'createdTime', label: 'Time', render: ({ data }: any) => timeFormat(data?.['createdDate']) },
    { id: 'name', label: 'From' },
    { id: 'username', label: 'Username' },
    { id: 'status', label: 'Status' },
    { id: 'amount', label: 'Total', render: ({ value }: any) => formatAmount(value) },
];
interface ParishonerActivityProps {
    navigationHandler: Function;
    data?: any;
}

function BasketActivityContainer({ navigationHandler, data }: ParishonerActivityProps) {
    const [searchText, setSearchText] = useState<string>('');
    const dispatch = useDispatch<AppDispatch>();
    const tableState = useSelector((state: RootState) => state.app.table);

    const _data = useMemo(() => {
        if (searchText) {
            dispatch(updateTableState({ ...tableState, pageNumber: 0 }));
            const _text = searchText.toLowerCase();
            return data.filter((u: BasketActivityUser) => u.name.toLowerCase().includes(_text) || u.username.toLowerCase().includes(_text));
        }
        return data;
    }, [data, dispatch, searchText]); // eslint-disable-line

    return (
        <Container sx={{ backgroundColor: 'white' }}>
            <div style={{ paddingTop: 8, marginTop: 8 }}>
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 12 }}>
                    <TextInput
                        backgroundColor="#F2F2F6"
                        height={50}
                        sx={{ mr: 2, color: '#F2F2F6' }}
                        width={'30%'}
                        icon={null}
                        placeholder="Total Gifts:"
                    />
                    <TextInput backgroundColor="#F2F2F6" height={50} width={'30%'} icon={null} placeholder="Last Auto Clear:" />
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 12 }}>
                    <div>
                        <Typography>Recent Activity</Typography>
                        <TableSortLabel sx={{ fontSize: 12, color: '#374151' }}>Today</TableSortLabel>
                    </div>
                    <TextInput
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        height={40}
                        backgroundColor="#F2F2F6"
                        sx={{ ml: 2, fontSize: 20, fontWeight: 400 }}
                        placeholder="Type name or emails..."
                    />
                </div>
                {/* TODO: Use the activity container component here */}
                <Table
                    successValue="Complete"
                    navigationHandler={navigationHandler}
                    columns={columns}
                    data={_data}
                    totalCount={_data.length}
                />
            </div>
        </Container>
    );
}

export default BasketActivityContainer;
